import { STORAGE_KEYS, storage } from '@/utils';

export const tokenStorage = {
  getAccessToken: (): string | null => storage.get<string>(STORAGE_KEYS.ACCESS_TOKEN),
  getRefreshToken: (): string | null => storage.get<string>(STORAGE_KEYS.REFRESH_TOKEN),
  setTokens: (accessToken: string, refreshToken: string): void => {
    storage.set(STORAGE_KEYS.ACCESS_TOKEN, accessToken);
    storage.set(STORAGE_KEYS.REFRESH_TOKEN, refreshToken);
  },
  clear: (): void => {
    storage.remove(STORAGE_KEYS.ACCESS_TOKEN);
    storage.remove(STORAGE_KEYS.REFRESH_TOKEN);
  },
};
